import { IncomingMessage } from 'http'

function checkCookie(cookieStr) {
  let isUserLoggedIn = false
  ;(cookieStr || '').split(';').forEach(value => {
    if (value?.trim()?.indexOf('user_id=') == 0 && value?.trim().split('=')[1]?.length > 0) {
      isUserLoggedIn = true
    }
  })
  return isUserLoggedIn
}

// todo move this to ui-kit
export const isLoggedIn = (req: IncomingMessage) => {
  // console.log(req.headers.cookie)
  let isUserLoggedIn = false
  if (typeof window !== 'undefined') {
    isUserLoggedIn = checkCookie(document.cookie)
  } else {
    isUserLoggedIn = checkCookie(req.headers?.cookie)
  }
  return isUserLoggedIn
}
